import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";

interface ProductTagsState {
    results: any[];
}


const initialState: ProductTagsState = {
    results: [],
};


const productTagsSlice = createSlice({
    name: "productTags",
    initialState,
    reducers: {
        setProductTags(state, action) {
            state.results = action.payload;
        },
    },
});


export const { setProductTags } = productTagsSlice.actions;

export const fetchProductTags = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getProductTags();
        dispatch(setProductTags(response));
    } catch (error) {
        console.error("Error retrieving product tags:", error);
    }
};

// Export the reducer
export default productTagsSlice.reducer;
